import React from 'react';

import { Circle, HalfCircle, FilledCircle, FilledHalfCircle } from './Shapes';

import styled from 'styled-components';


const Skill = styled('p')`
  margin-right:4vw;
  font-size:1.3rem;
  font-weight:bold;
  z-index:3;
`

export default function Skills() {
  return <div style={{
    backgroundColor:'var(--secondary-bg-color)',
    color:'var(--primary-bg-color)',
    display:'flex',
    flexDirection:'column',
    paddingTop:30,
    width:'100%',
    flex: 1,
    paddingBottom:30,
    position: 'relative',
    borderBottom:'3px dashed var(--tertiary-color-b)',
  }}>
    <h2 style={{
      textAlign:'left', 
      width:'auto',
      backgroundColor:'var(--primary-bg-color)',
      color:'var(--primary-text-color)',
      paddingLeft:20,
      zIndex:2,
      }}>
      Skills
    </h2>
    <div style={{
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-around',
      flexWrap:'wrap',
      color:'var(--primary-bg-color)'
    }}>
      <Skill>
        Frontend <br/>
        Backend <br/>
        Cloud Infra
      </Skill>
      <Skill>
        Research <br/>
        Algorithms <br/>
        Smart Contracts
      </Skill>
      <Skill>
        Data Sci <br/>
        Data Viz <br/>
        Algo Trading
      </Skill>
    </div>
    <h2 style={{
      textAlign:'left', 
      paddingLeft:20,
      backgroundColor:'var(--primary-bg-color)',
      color:'var(--primary-text-color)',
      }}>
      Languages & Tools
    </h2>
    <div style={{
      display:'flex',
      flexDirection:'row',
      justifyContent:'space-around',
      flexWrap:'wrap',
      color:'var(--primary-bg-color)'
    }}>
      <Skill>
        Html & Css <br/>
        Javascript <br/>
        Python <br/>
        React <br/>
        AWS <br/>
        <span style={{fontSize:'2.8rem'}}> **** </span>
      </Skill>
      <Skill>
        C# <br/>
        Flask <br/>
        Mongo <br/>
        Postgres <br/>
        Numpy & Pandas <br/>
        <span style={{fontSize:'2.8rem'}}> *** </span>
      </Skill>
      <Skill>
        Firebase <br/>
        Solidity <br/>
        Java <br/>
        C++ <br/> <br/>
        <span style={{fontSize:'2.8rem'}}> ** </span>
      </Skill>
    </div>


      {/* Top Left Circle */}
      <FilledCircle 
          size={240}
          color={'var(--primary-bg-color)'}
          style={{
              zIndex:1,
              top:-120, left: 95,
              transform: 'rotateX(-180deg)'}}/>

  </div>
}
